import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';

const AppointmentTable = () => {
    useEffect(() => {
        const table = $('#dataTable').DataTable({
            pageLength: 10,
        });
        return () => {
            table.destroy(true);
        };
    }, []);
    return (
        <div className="card basic-data-table">
            <div className="card-header">
                <h5 className="card-title mb-0">Appointments Details</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0 small"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">Sr.#</th>
                            <th scope="col">Center Name</th>
                            <th scope="col">Total Appointments</th>
                            <th scope="col">Schedule Appointments</th>
                            <th scope="col">Finished Appointments</th>
                            <th scope="col">Cancelled Appointments</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>01</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC TN Mambalam</Link>
                            </td>
                            <td>5000</td>
                            <td>3000</td>
                            <td>2000</td>
                            <td>1000</td>
                        </tr>
                        <tr>
                            <td>02</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC KA Banasankari</Link>
                            </td>
                            <td>4000</td>
                            <td>2500</td>
                            <td>1500</td>
                            <td>1000</td>
                        </tr>
                        <tr>
                            <td>03</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Dadar</Link>
                            </td>
                            <td>4500</td>
                            <td>2700</td>
                            <td>1800</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>04</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC KA Kundalahalli</Link>
                            </td>
                            <td>4800</td>
                            <td>2900</td>
                            <td>1900</td>
                            <td>1000</td>
                        </tr>
                        <tr>
                            <td>05</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Virar</Link>
                            </td>
                            <td>3500</td>
                            <td>2200</td>
                            <td>1300</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>06</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Andheri</Link>
                            </td>
                            <td>4200</td>
                            <td>2600</td>
                            <td>1600</td>
                            <td>1000</td>
                        </tr>
                        <tr>
                            <td>07</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>08</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>09</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td>
                                <Link to="#" className="text-primary-600">SHC MH Vashi</Link>
                            </td>
                            <td>3900</td>
                            <td>2400</td>
                            <td>1500</td>
                            <td>900</td>
                        </tr>



                    </tbody>
                </table>
            </div>
        </div>

    )
}

export default AppointmentTable